import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";
var _templateObject, _templateObject2, _templateObject3;
import { css, memoizeStyle } from "../../../lib/theming/Emotion";
export var styles = memoizeStyle({
  root: function root(t) {
    var width = parseInt(t.calendarCellWidth) * 7;
    return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      background: ", ";\n      box-sizing: content-box;\n      border-radius: ", ";\n      color: ", ";\n      display: block;\n      padding: 0 ", ";\n      width: ", "px;\n      touch-action: none;\n    "])), t.calendarBg, t.calendarBorderRadius, t.textColorDefault, t.calendarPaddingX, width);
  },
  wrapper: function wrapper() {
    return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n      font-size: 14px;\n      position: relative;\n      overflow: hidden;\n    "])));
  },
  separator: function separator(t) {
    return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n      border-bottom: ", ";\n      margin: 0 ", ";\n    "])), t.calendarBottomSeparatorBorder, t.calendarMonthTitleMarginX);
  }
});